import { defineMessage, IntlShape } from "react-intl";

const timeMessage = defineMessage({
  id: "dashboard.cards.formatSeconds",
  defaultMessage:
    "{hour, select, false {} other {{hour}h}}{minute, select, false {} other {{hour, select, false {} other { }}{minute}m}}{second, select, false {} other {{minute, select, false {} other { }}{second}s}}",
  description: "Format time for customer facetime",
});

const formatSeconds = (intl: IntlShape, seconds: number) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  return intl.formatMessage(timeMessage, {
    hour: hours > 0 ? hours : false,
    minute: minutes > 0 || hours > 0 ? minutes : false,
    second: !hours ? secs : false,
  });
};

export default formatSeconds;
